import { Component } from '@angular/core';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  IconComponent,
  RegisterAnotherApplianceComponent,
  RegisteredApplianceSummaryComponent,
} from '@components';
import { provideTranslationDictionaryMapping, TranslatePipe } from '@i18n';
import { translation } from '../../i18n/translation.constant';

@Component({
  selector: 'app-registration-confirmation',
  imports: [
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    IconComponent,
    RegisterAnotherApplianceComponent,
    RegisteredApplianceSummaryComponent,
    TranslatePipe,
  ],
  templateUrl: './registration-confirmation.component.html',
  styleUrls: ['./registration-confirmation.component.scss'],
  providers: [provideTranslationDictionaryMapping(translation)],
})
export class RegistrationConfirmationComponent {}
